<template>
  <div class="main-layout">
    <div class="main-content" ref="contentRef">
      <router-view v-slot="{ Component }">
        <keep-alive :include="cachedComponents">
          <component :is="Component" />
        </keep-alive>
      </router-view>
    </div>
    <BottomTabBar />
  </div>
</template>

<script setup>
import { computed } from 'vue'
import BottomTabBar from '@/components/BottomTabBar.vue'
import router from '@/router'

const cachedComponents = computed(() => {
  const routes = router.options.routes
  const collect = []
  function findKeepAlive(routes) {
    routes.forEach(route => {
      if (route.meta?.keepAlive) {
        collect.push(route.name)
      }
      if (route.children) {
        findKeepAlive(route.children)
      }
    })
  }
  findKeepAlive(routes)
  return collect
})
</script>

<style scoped>
.main-layout {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #f5f7fa;
}

.main-content {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: calc(56px + env(safe-area-inset-bottom));
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0;
}

.main-content::-webkit-scrollbar {
  display: none;
}
</style>
